import { createAsyncThunk } from '@reduxjs/toolkit'

const setLoading = createAsyncThunk<
	boolean,
	boolean
>('core/loading', async (obj) => obj)

export { setLoading }
